export default __webpack_public_path__ + "static/quipping-50d537700fabe9cacbfcf91da353f703.svg";